(function () {
    'use strict';

    angular
        .module('observationModule')
        .controller('grcObservationListController', Controller);

    Controller.$inject = ['$scope', 'grcObservationService','grcControlService'];

    function Controller($scope, grcObservationService, grcControlService) {

        if (_.isArray($scope.boxModel)) {
            $scope.observations = $scope.boxModel;
        }

        if (!_.isUndefined($scope.boxModel.ControlTestID)) {

            // Get Test Results
            grcControlService.getTestResults($scope.boxModel.ControlID, $scope.boxModel.ControlTestID)
                 .then(function (testResults) {
                     $scope.controlTestResults = testResults;
                 });

            // Get Observations
            grcObservationService
                 .getObservationsByControlTestID($scope.boxModel.ControlID, $scope.boxModel.ControlTestID)
                 .then(function (observations) {
                     $scope.observations = observations;
                 });
        }
        else if (!_.isUndefined($scope.boxModel.ControlID)) {

            // Get Observations
            grcObservationService
                 .getObservationsByControlID($scope.boxModel.ControlID)
                 .then(function (observations) {
                     $scope.observations = observations;
                 });
        }
        else if (!_.isUndefined($scope.boxModel.GovernanceProcessID)) {
         
            // Get Observations
            grcObservationService
                 .getObservationsByGovernanceProcess($scope.boxModel.GovernanceProcessID)
                 .then(function (observations) {
                     $scope.observations = observations;
                 });
        }

        // Is Observation From Actual Test Result
        $scope.isObservationFromActualTestResult = function (observation) {
            if (_.isUndefined($scope.controlTestResults)) return false;
            if (_.isUndefined($scope.controlTestResults.ActualTestResult)) return false;

            return observation.TestResultID === $scope.controlTestResults.ActualTestResult.TestResultID;
        };
    }
})();